import React, { useContext, useEffect } from 'react'
import './Login.css'
import { Link, useHistory } from 'react-router-dom'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { useFormik } from 'formik'
import AuthContext from '@/product/context/auth/authContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import { useTranslation } from 'react-i18next'
import { Button, Tooltip } from '@material-ui/core'
import SignContext from '@/custom/context/signContext'

const LoginComponent = (props) => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const { t } = useTranslation()
    const { setLoginPopup } = useContext(SignContext)
    const { login, responseStatus, clearResponse, isAuthenticated } = authContext
    const { handleForgotPasswordPopup } = useContext(SignContext)

    // useEffect(() => {
    //     if (isAuthenticated) {
    //         handleRedirectInternal(history, '')
    //     }
    // }, [isAuthenticated])

    const rememberMe = {
        formik: props.formik,
        data: [
            {
                label: 'Stay Signed In',
                name: 'remember_me',
                type: 'checkbox',
                placeholder: 'remember_me',
                class: '',
            },
        ],
    }
    const loginInfo = {
        formik: props.formik,
        data: props.loginInfo,
    }

    useEffect(() => {
        if (localStorage.getItem('token')) {
            setLoginPopup(false)
        }
    })
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'login') {
                if (responseStatus.status === 'success') {
                    if (props.onSuccess) {
                        props.onSuccess()
                    } else {
                        // handleRedirectInternal(history, '')
                    }
                }
            }
        }
    }, [responseStatus])

    return (
        <form onSubmit={props.formik.handleSubmit} className="">
            <div className="row">{Object.values(mapData(loginInfo))}</div>
            <div className="d-flex loginActBox justify-content-center align-items-center mb-1">
                <Button onClick={handleForgotPasswordPopup}>Reset your password?</Button>
            </div>

            <PrimaryButton id="login_button" label="Login" type="submit" />

            <p className="supportmail">
                If you are having trouble logging in, please email{' '}
                <a href="mailto:support@zipperbuy.com">support@zipperbuy.com</a>.
            </p>

            {/* {process.env.REACT_APP_ADMIN_DOMAIN ? (
                <div className="d-flex justify-content-center align-items-center sellerLoginHelper">
                    <p className="mb-0">Have a Seller account?</p>
                    <Button
                        onClick={() => {
                            window.open(process.env.REACT_APP_ADMIN_DOMAIN, '_blank')
                        }}
                    >
                        Login here
                    </Button>
                </div>
            ) : null} */}
        </form>
    )
}

export default LoginComponent
